export default function isPrerender() {
  return navigator.userAgent.toLowerCase().includes('prerender');
}
